import { render, staticRenderFns } from "./SwapRejectedByTheUserStep.vue?vue&type=template&id=2aa04208"
import script from "./SwapRejectedByTheUserStep.vue?vue&type=script&lang=ts"
export * from "./SwapRejectedByTheUserStep.vue?vue&type=script&lang=ts"
import style0 from "./SwapRejectedByTheUserStep.vue?vue&type=style&index=0&id=2aa04208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports